import { createClient } from '@supabase/supabase-js';

const url = process.env.REACT_APP_SUPABASE_URL;
const key = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const SUPABASE_LISTO = Boolean(url && key && !key.includes('PENDIENTE'));

// El esquema de negocio vive en "hueco" (debe estar expuesto en Settings -> API -> Exposed schemas).
export const supabase = createClient(url || 'https://placeholder.supabase.co', key || 'placeholder', {
  db: { schema: 'hueco' },
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
});

// Dominio canónico FIJO. Se usa para artefactos que perduran fuera de la sesión y del entorno:
// QR impresos (viven años) y enlaces de correo. NUNCA window.location.origin: un QR impreso desde la
// preview moriría con ella. Entre el usuario por donde entre, estos apuntan siempre a producción.
export const CANONICAL_URL = process.env.REACT_APP_CANONICAL_URL || 'https://hueco.getagentik.co';
// Solo para navegación interna dentro del entorno actual (preview o producción).
export const APP_BASE_URL = window.location.origin;
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

// Cabecera con el access token del usuario para que el backend delgado aplique rate-limit por usuario.
export async function authHeader() {
  const { data } = await supabase.auth.getSession();
  const tok = data?.session?.access_token;
  return tok ? { Authorization: `Bearer ${tok}` } : {};
}
